import { useState } from 'react'
import { createParam } from 'solito'
import { ArticleCategoryScreen } from './article-category-screen'
import { useCategoryArticlesQuery, categoryArticlesQuery, useArticleCategoryQuery } from './queries'

const { useParam } = createParam<{ slug: string }>()

export const ArticleCategoryScreenContainer = () => {
  const [slug] = useParam('slug')
  const [refreshing, setRefreshing] = useState(false)
  const {
    data: categoryData,
    refetch: refretchArticleCategory
  } = useArticleCategoryQuery({
    slug: slug || '',
  })
  const {
    data,
    refetch: refetchArticles,
    fetchMore,
    networkStatus
  } = useCategoryArticlesQuery(
    {
      slug: slug || '',
      ...categoryArticlesQuery.defaultVariables,
    },
    {
      notifyOnNetworkStatusChange: true,
    }
  )

  const handlePullToRefresh = async () => {
    setRefreshing(true)
    await Promise.all([refretchArticleCategory(), refetchArticles()])
    setRefreshing(false)
  }

  const handleLoadMore = () => {
    fetchMore({
      variables: {
        page: (data?.fetchArticlesByCategory?.page || 0) + 1,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return prev
        }
        return {
          fetchArticlesByCategory: {
            ...fetchMoreResult.fetchArticlesByCategory,
            docs: [
              ...(prev.fetchArticlesByCategory?.docs || []),
              ...(fetchMoreResult.fetchArticlesByCategory?.docs || []),
            ],
          },
        }
      },
    })
  }

  const hasMore =
    (data?.fetchArticlesByCategory?.page || 0) < (data?.fetchArticlesByCategory?.totalPages || 0)

  const loading = networkStatus === 1
  const fetchingMore = networkStatus === 3

  return (
    <ArticleCategoryScreen
      loading={loading}
      articleCategory={categoryData?.ArticleCategories?.docs?.[0]}
      articles={data?.fetchArticlesByCategory?.docs || []}
      fetchingMore={fetchingMore}
      hasMore={hasMore}
      onLoadMore={handleLoadMore}
      refreshing={refreshing}
      onPullToRefresh={handlePullToRefresh}
    />
  )
}
